import { AcceptFileType } from './form';
import { AcceptedFileTypeKeys } from './enums';

export const ACCEPTED_FILE_TYPES: AcceptFileType = {
  [AcceptedFileTypeKeys.JPEG]: {
    'image/jpeg': [],
  },
  [AcceptedFileTypeKeys.PNG]: {
    'image/png': [],
  },
  [AcceptedFileTypeKeys.GIF]: {
    'image/gif': [],
  },
  [AcceptedFileTypeKeys.PDF]: {
    'application/pdf': [],
  },
  [AcceptedFileTypeKeys.RTF]: {
    'text/rtf': [],
  },
  [AcceptedFileTypeKeys.DOCX]: {
    'application/msword': ['.doc', '.docx'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
      '.doc',
      '.docx',
    ],
  },
  [AcceptedFileTypeKeys.XLSX]: {
    'application/vnd.ms-excel': ['.xls', '.xlsx'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xls',
      '.xlsx',
    ],
  },
  [AcceptedFileTypeKeys.PPTX]: {
    'application/vnd.ms-powerpoint': ['.ppt', '.pptx'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
      ['.ppt', '.pptx'],
    'application/vnd.openxmlformats-officedocument.presentationml.slideshow': [
      '.ppt',
      '.pptx',
    ],
  },
};

export const pricingAcceptedFileTypes = [
  AcceptedFileTypeKeys.JPEG,
  AcceptedFileTypeKeys.PNG,
  AcceptedFileTypeKeys.GIF,
  AcceptedFileTypeKeys.PDF,
  AcceptedFileTypeKeys.RTF,
  AcceptedFileTypeKeys.DOCX,
  AcceptedFileTypeKeys.XLSX,
  AcceptedFileTypeKeys.PPTX,
];
